<template>
	<ArticleTeaser
		:categories="article.category"
		:link="article.articleLink"
		:image="article.image"
		:ingress="article.ingress"
		:to="article.internalLink"
		:full-width="component.content && component.content.fullWidth"
		:heading="article.heading"
	></ArticleTeaser>
</template>

<script>
export default defineNuxtComponent({
	name: "ContentOneArticle",
	props: ["component"],

	computed: {
		article() {
			return this.component.content && this.component.content.article;
		},
		link() {
			return this.article.articleLink;
		},
	},
});
</script>
